import React, { CSSProperties } from "react";
import { useTranslation, Trans } from "next-i18next";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import {
    LowerNoiseCost, Docker, K8s, Linux, ControlDataBySource, ChangeRulesRedeploys, Windows
} from "../../components/v2/icons";
import Testimonial from "../../components/v2/mw-carousel/testimonial";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import ProductHeroSection from "../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import CallToActionDocsLink from "../../components/v2/blog/call-to-action-docs-link";
import '../../styles/scss/_faq-section.module.scss';

export default function Pipeline() {
    const { t } = useTranslation("common");
    const featuresData = t("platform.pipelineV2.features.detailedFeatures", { returnObjects: true }) as any[];
    const features = Array.isArray(featuresData) ? featuresData : [];
    const faqsData = t("platform.pipelineV2.faq.questions", { returnObjects: true }) as any[];
    const faqs = Array.isArray(faqsData) ? faqsData : [];
    const resourceData = t("platform.pipelineV2.resources", { returnObjects: true }) as any[];
    const resource = Array.isArray(resourceData) ? resourceData : [];
    const cardsData = t("platform.pipelineV2.benefitCards", { returnObjects: true }) as any[];
    const cards = Array.isArray(cardsData) ? cardsData : [];

    return (
        <>

            <ProductHeroSection title={<h1>{t("platform.pipelineV2.hero.titlePrefix")}<span> {t("platform.pipelineV2.hero.titleHighlight")}</span></h1>}
                description={t("platform.pipelineV2.hero.description")}
                img={"/images/platform/observability-pipelines.webp"} imgMobile={"/images/platform/observability-pipelines-mobile.webp"} imgAlt={t("platform.pipelineV2.hero.imageAlt")} preloadImg
                hasActions={true} tips={t("product.hero.tips")} />

            <section className={'mw-card-with-icon product-page'}>
                <div className={'container'}>
                    <h2>
                        <Trans
                            i18nKey="platform.pipelineV2.section.title"
                            components={{ highlight: <span className={"text-gradient"} /> }}
                        />
                    </h2>
                    <p>{t("platform.pipelineV2.section.description")}</p>
                    <div className={'card-items'}>
                        <div className={'d-flex card-items'}>
                            <CardWithIcon icon={<LowerNoiseCost />}
                                title={cards[0]?.title}
                                description={cards[0]?.description} />
                            <CardWithIcon icon={<ControlDataBySource />} title={cards[1]?.title}
                                description={cards[1]?.description} />
                            <CardWithIcon icon={<ChangeRulesRedeploys />} title={cards[2]?.title}
                                description={cards[2]?.description} />
                        </div>
                    </div>
                </div>
            </section>

            <FeaturesMonitoring productFeatures={features}
                title={<h2><Trans i18nKey="platform.pipelineV2.features.title" components={{ highlight: <span className={"text-gradient"} /> }} /></h2>} tourId={""} isTryOut={true} />

            <CallToActionDocsLink
                title={t("platform.pipelineV2.ctaTitle")}
                docsLink="https://docs.middleware.io/admin/settings/agent-pipeline"
            />
            <Testimonial />

            <ProductResources resources={resource} title={t("product.shared.resources.title")} />

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{t("platform.pipelineV2.faq.title")}</h2>
                    <p>{t("platform.pipelineV2.faq.subtitle")}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs.map((faq) => ({
                            ...faq,
                            text: <p>{faq.text}</p>
                        }))} showGroups={true} />
                    </div>
                </div>
            </section>

        </>
    )
}